export default __webpack_public_path__ + "static/board-a15d0d100cfbb8e2a03b411c4fe06e33.jpg";